import { render, staticRenderFns } from "./ProductVideoShelf.vue?vue&type=template&id=5431e0a6&scoped=true"
import script from "./ProductVideoShelf.vue?vue&type=script&lang=js"
export * from "./ProductVideoShelf.vue?vue&type=script&lang=js"
import style0 from "./ProductVideoShelf.vue?vue&type=style&index=0&id=5431e0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431e0a6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductVideoPreview: require('/app/components/ProductVideoPreview.vue').default})
